import { queryAll } from '@pwup/dom/query';

import Module from "../module/Module";
import TextImageParallax from "./TextImageParallax";

export const SELECTOR = '[data-text-image-parallax]';

class Factory extends Module {
  constructor(init = false) {
    super();

    init ? this.init() : null;
  }

  get name() {
    return "TextImageParallax";
  }

  init() {
    // set initialized
    this.initialized = true;
    this.items = [ ...queryAll(SELECTOR) ].map(el => new TextImageParallax(el, this.emitter));
  }
}

export default Factory;
